import { ApplicationConfig, Nullable } from '@bybeam/platform-types';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import React, { useContext } from 'react';
import { getApplicationConfiguration } from '../../utilities/application/configs/index.js';

// This is really only intended to be used in stories/tests so we can test things
// with configs that don't actually exist, don't recommend using it in an actual implementation
export const ApplicationConfigContext = React.createContext<ApplicationConfig>(undefined);

export default function useApplicationConfig(): Nullable<ApplicationConfig> {
  const program = useProgram();

  const { user } = useAuth();
  const contextConfig = useContext(ApplicationConfigContext);
  if (contextConfig) return contextConfig;

  if (!program) return null;

  return getApplicationConfiguration(program, user.core);
}
